<template>
  <div class="staffSide common_content">
    <div class="side1">
      <div class="title">
        <span>
          {{title}}
          <img :src="src" class="icon" />
        </span>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <router-link :to="item.path" :class="item.path == navPath ?'light':''">{{item.name}}</router-link>
        </li>
      </ul>
      <div class="decoration"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    src: String,
    list: Array
  },
  data() {
    return {
      navPath: ""
    };
  },
  watch: {
    $route() {
      this.checkRouterLocal();
    }
  },
  created() {
    this.checkRouterLocal();
  },
  methods: {
    // 检索当前路径
    checkRouterLocal() {
      // 查找当前路由下标高亮
      this.navPath = this.$route.fullPath;
    }
  }
};
</script>

<style scoped lang="less">
.staffSide {
  width: 100%;
  .title {
    height: 60px;
    background: url("/image/evaluationStaff/title_bg.jpg");
    //background-size:cover;
    color: #ffffff;
    font-weight: bold;
    text-align: center;
    line-height: 60px;

    span {
      position: relative;
      .icon {
        width: 35px;
        height: 35px;
        position: absolute;
        top: -40%;
      }
    }
  }
  ul {
    background: #ffffff;
    li a {
      display: block;
      width: 100%;
      padding: 10px 0;
      text-align: center;
      color: #4e4e4e;
      font-size: 15px;
    }
    .light {
      background: #17a1e6 url("/image/evaluationStaff/ball.png") no-repeat right
        13% top 47%;
      color: #ffffff;
    }
  }
  /*.el-tabs__item.is-active{*/
  /*background: #17A1E6 url('/image/evaluationStaff/ball.png') no-repeat right 27% top 47% ;*/
  /*color: #FFFFFF;*/
  /*}*/
  .decoration {
    width: 100%;
    height: 500px;
    background: url("/image/evaluationStaff/decoration.jpg") no-repeat;
  }
}
@media screen and (max-width: 767px) {
  .staffSide {
    .title {
      height: 43px;
      line-height: 43px;
      .icon {
        width: 25px;
        height: 25px;
        top: 19%;
      }
    }
    .decoration {
      display: none;
    }
  }
}
</style>
